import { get, isEmpty } from 'lodash';

import { refreshBrandGuestTokenApi, refreshGuestTokenApi } from '../api/api';
import { storageTypes } from '../constants/globals';
import { DISPATCH_AUTH_TOKEN } from './authentication/actionType';
import { isNativeWebView } from '../utils/helpers';
import { getItem, setItem } from '../utils/storage';

export const resolveAuthRefreshContext = (state) => {
  const brandGuestData = getItem(storageTypes.localStorage, 'BrandGuestData');
  const context = !isEmpty(brandGuestData) ? 'brandGuest' : 'guest';
  const authData =
    getItem(storageTypes.localStorage, 'AuthData') || get(state, 'authentication.authData', {});
  const refreshToken = get(authData, 'refreshToken', '');

  return { context, refreshToken };
};

export const updateAuthTokensAction =
  ({ accessToken, refreshToken }) =>
  async (dispatch, getState) => {
    const existingAuthData =
      getItem(storageTypes.localStorage, 'AuthData') ||
      get(getState(), 'authentication.authData', {});
    const nextAuthData = {
      ...existingAuthData,
      ...(accessToken ? { accessToken } : {}),
      ...(refreshToken ? { refreshToken } : {}),
    };

    dispatch({
      type: DISPATCH_AUTH_TOKEN,
      authData: nextAuthData,
    });

    try {
      setItem(storageTypes.localStorage, 'AuthData', nextAuthData);

      if (isNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            eventType: { type: 'loginData', data: { auth: nextAuthData } },
          }),
        );
      }
    } catch (e) {
      // Best-effort; do not block token refresh.
    }
  };

export const refreshTokenAction = () => async (_dispatch, getState) => {
  const state = getState();
  const { context, refreshToken } = resolveAuthRefreshContext(state);

  if (!refreshToken) {
    return { isError: true, error: new Error('Missing refresh token'), context };
  }

  try {
    const response =
      context === 'brandGuest'
        ? await refreshBrandGuestTokenApi(refreshToken)
        : await refreshGuestTokenApi(refreshToken);
    const accessToken = get(response, 'data.accessToken', '');
    const nextRefreshToken = get(response, 'data.refreshToken', '');

    if (!accessToken || !nextRefreshToken) {
      return { isError: true, error: new Error('Refresh token response missing tokens'), context };
    }

    return { accessToken, refreshToken: nextRefreshToken, context };
  } catch (error) {
    return { isError: true, error, context };
  }
};
